<div class="otp-container">
	<div class="otp-section-title-wrap">
	<div class="row section-head ftp-title-row">
		<div class="col-12 d-flex align-items-center">
			<label class="checkbox-label ftp-title-checkbox" [ngClass]="{'otp-corrupt-disabled': hasOtpValidationError}" for="OTP-ftp-enable" [attr.title]="hasOtpValidationError ? otpValidationMessage : null">
				<input
					type="checkbox"
					class="primary-checkbox"
					[ngClass]="{'otp-corrupt-checkbox': hasOtpValidationError, 'otp-corrupt-disabled': hasOtpValidationError}"
					[checked]="ftpEnabled"
					[disabled]="hasOtpValidationError"
					(change)="onFtpCheckChange($event)"
					id="OTP-ftp-enable"
					aria-labelledby="OTP-ftp-title"
				/>
				<span class="extra-border-enablefeat" [ngClass]="{'otp-corrupt-checkbox': hasOtpValidationError, 'otp-corrupt-disabled': hasOtpValidationError}" id="OTP-ftp-checkbox"></span>
			</label>
			<div class="signifyBookmd signifyBoldmd otp-title" id="OTP-ftp-title">Fixture Temperature Protection (UL60730, SREC)</div>
		</div>
	</div>
	</div>
  <div class="row dtp-summary-row" id="OTP-dtp-summary" [ngClass]="{'isResetDisabled': !ftpEnabled}">
		<div class="col-12 signifyBookmd dtp-summary-text" id="OTP-dtp-summary-text">Driver Temperature Protection: Start dim: 83°C, Stop dim: 87°C</div>
	</div>

	<div class="row otp-graph-row" [ngClass]="{'isResetDisabled': !ftpEnabled}">
		<div class="col-2 otp-legend-col">
			<div class="radio-group otp-radio-stack">
				<label class="radio-label signifyBookmd" aria-hidden="true">
					<input
						type="radio"
						class="dimming-radio"
						name="otpFtpMode"
						value="dlmFlex"
						[(ngModel)]="ftpOption"
					(ngModelChange)="onFtpOptionChange($event)"				[disabled]="!ftpEnabled"					id="OTP-ftp-dlm-radio"
				/>
				DLM Flex Compatible
			</label>
				<label class="radio-label signifyBookmd" aria-hidden="true">
					<input
						type="radio"
						class="dimming-radio"
						name="otpFtpMode"
						value="customNtc"
						[(ngModel)]="ftpOption"
						(ngModelChange)="onFtpOptionChange($event)"					[disabled]="!ftpEnabled"						id="OTP-ftp-custom-radio"
					/>
					Custom NTC
				</label>
			</div>
		</div>
		@if (!quickConfigvalue) {
			<div class="col-10 otp-chart-col">
				<app-otp-ftp-graph></app-otp-ftp-graph>
			</div>
		}
	</div>

	<div class="row slider-container activedim-margin" [ngClass]="{'isResetDisabled': !ftpEnabled || ftpOption === 'dlmFlex'}">
		<div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="OTP-ftp-startdim-label">Start dim</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="OTP-ftp-start-STDmin"> min {{ ftpResistanceMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="OTP-ftp-start-STDmax"> max {{ ftpResistanceMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="OTP-ftp-start-min">{{ ftpResistanceMin }}</span>
			<div class="col-6 curvePadding sliderCss" id="OTP-ftp-start-slider" [ngClass]="{'isSliderClick': !ftpEnabled || ftpOption === 'dlmFlex'}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="OTP-ftp-start-range"
					[value]="getSliderSafeValue(ftpStartNtc, dimStartMin, dimStartMax)"
					[options]="ftpStartDimOptions"
					(userChangeEnd)="ftpStartNtcChange($any($event).value)"
				>
				</ngx-slider>
			</div>
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="OTP-ftp-start-max">{{ ftpResistanceMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="ftpStartNtcDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['dimStart'], 'isResetDisabled custom-inputbox-disabled': !ftpEnabled || ftpOption === 'dlmFlex', 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="!ftpEnabled || ftpOption === 'dlmFlex'"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'dimStart')"
				(blur)="onFieldBlur($any($event.target), 'dimStart')"
				id="OTP-ftp-start-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&Omega;@if (ftpOption === 'dlmFlex' && ftpEnabled && !quickConfigvalue) { (&#8776; {{ ftpStartTempLabel }}&deg;C) }</p>
		</div>
	</div>

	<div class="row slider-container" [ngClass]="{'isResetDisabled': !ftpEnabled || ftpOption === 'dlmFlex'}">
		<div class="col-1 label signifyBookmd dim-margin zero-margin-top" id="OTP-ftp-stopdim-label">Stop dim</div>
		@if (quickConfigvalue) {
			<div class="col-2">
				<div class="row">
					<div class="col-4"></div>
					<div class="col-2 minValMargin">
						<span class="signifyBookmd minValue" id="OTP-ftp-stop-STDmin"> min {{ ftpResistanceMin }}</span>
					</div>
					<div class="col-3">
						<span class="signifyBookmd maxValue" id="OTP-ftp-stop-STDmax"> max {{ ftpResistanceMax }}</span>
					</div>
				</div>
			</div>
		}
		@if (!quickConfigvalue) {
			<span class="signifyBookmd text-mindim sliderMinValue col-1" id="OTP-ftp-stop-min">{{ ftpResistanceMin }}</span>
			<div class="col-6 curvePadding sliderCss" id="OTP-ftp-stop-slider" [ngClass]="{'isSliderClick': !ftpEnabled || ftpOption === 'dlmFlex'}">
				<ngx-slider
					type="normalType"
					ngDefaultControl
					id="OTP-ftp-stop-range"
					[value]="getSliderSafeValue(ftpStopNtc, dimStopMin, dimStopMax)"
					[options]="ftpStopDimOptions"
					(userChangeEnd)="ftpStopNtcChange($any($event).value)"
				>
				</ngx-slider>
			</div>
			<span class="signifyBookmd text-mindim col-1 startUpMargin" id="OTP-ftp-stop-max">{{ ftpResistanceMax }}</span>
		}
		<div class="row form-group col-3">
			<input
				type="number"
				[value]="ftpStopNtcDisplay"
				class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
				[ngClass]="{'myStyle': inputError['dimStop'], 'isResetDisabled custom-inputbox-disabled': !ftpEnabled || ftpOption === 'dlmFlex', 'inputCssStandard': quickConfigvalue === true}"
				[disabled]="!ftpEnabled || ftpOption === 'dlmFlex'"
				(keypress)="numberOnly($event)"
				(input)="onFieldInput($any($event.target).value, 'dimStop')"
				(blur)="onFieldBlur($any($event.target), 'dimStop')"
				id="OTP-ftp-stop-input"
			/>
			<p class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&Omega;@if (ftpOption === 'dlmFlex' && ftpEnabled && !quickConfigvalue) { (&#8776; {{ ftpStopTempLabel }}&deg;C) }</p>
		</div>
	</div>

	@if (ftpOption === 'customNtc') {
		<div class="row note-back-new otp-note-row" id="OTP-ftp-note1">
			<span class="col-11 note-text signifyBookmd"><span class="signifyBoldmd">Note 1:</span> Use an UL Certified NTC thermistor with a nominal resistance of 15 k&Omega; to 100 k&Omega;, &plusmn;1% tolerance.</span>
		</div>
		<div class="row note-back-new otp-note-row otp-note-row-2" id="OTP-ftp-note2">
			<span class="col-11 note-text signifyBookmd"><span class="signifyBoldmd">Note 2:</span> Choose the NTC resistance value of the Stop dim and the Start dim to ensure corresponding the Stop dim temperature at least 5°C higher than the Start dim temperature.</span>
		</div>
	}


	<div class="otp-section-title-wrap">
	<div class="row section-head ftp-title-row dtp-head">
		<div class="col-12 d-flex align-items-center">
			<label class="checkbox-label ftp-title-checkbox" [ngClass]="{'otp-corrupt-disabled': hasOtpValidationError}" for="OTP-dtp-enable" [attr.title]="hasOtpValidationError ? otpValidationMessage : null">
				<input
					type="checkbox"
					class="primary-checkbox"
					[ngClass]="{'otp-corrupt-checkbox': hasOtpValidationError, 'otp-corrupt-disabled': hasOtpValidationError}"
					[checked]="dtpEnabled"
					[disabled]="hasOtpValidationError"
					(change)="onDtpCheckChange($event)"
					id="OTP-dtp-enable"
					aria-labelledby="OTP-dtp-title"
				/>
				<span class="extra-border-enablefeat" [ngClass]="{'otp-corrupt-checkbox': hasOtpValidationError, 'otp-corrupt-disabled': hasOtpValidationError}" id="OTP-dtp-checkbox"></span>
			</label>
			<div class="signifyBookmd signifyBoldmd otp-title" id="OTP-dtp-title">Driver Temperature Protection</div>
		</div>
	</div>
	</div>

	<div class="row otp-graph-row otp-dtp-graph-row" [ngClass]="{'isResetDisabled': !dtpEnabled}">
		<div class="col-2 otp-legend-col">
			<div class="radio-group otp-radio-stack">
				<label class="radio-label signifyBookmd" aria-hidden="true">
					<input
						type="radio"
						class="dimming-radio"
						name="otpDtpMode"
						value="83to87"
						[(ngModel)]="dtpOption"
						(ngModelChange)="onDtpOptionChange($event)"					[disabled]="!dtpEnabled"						id="OTP-dtp-8387-radio"
					/>
					83 - 87&deg;C
				</label>
				<label class="radio-label signifyBookmd" aria-hidden="true">
					<input
						type="radio"
						class="dimming-radio"
						name="otpDtpMode"
						value="92to97"
						[(ngModel)]="dtpOption"
						(ngModelChange)="onDtpOptionChange($event)"					[disabled]="!dtpEnabled"						id="OTP-dtp-9297-radio"
					/>
					92 - 97&deg;C
				</label>
			</div>
		</div>
		@if (!quickConfigvalue) {
			<div class="col-10 otp-chart-col">
				<app-otp-dtp-graph></app-otp-dtp-graph>
			</div>
		}
	</div>
</div>
